<template>
  <div ref="loader" class="workflow-loader">
    <component v-if="editor" :is="editor" />
    <div v-else class="demo-loading">
      <p class="odin-eyebrow">INTERACTIVE WORKFLOW · SAMPLE DATA</p>
      <h3>Try a workflow in your browser.</h3>
      <p>
        Adjust a threshold and see which updates reach ODIN. No account needed.
      </p>
      <button class="green-btn odin-button" :disabled="loading" @click="load">
        {{ loading ? "Loading workflow…" : "Load interactive demo" }}
      </button>
      <p v-if="failed" role="alert">
        The demo could not load. Check your connection and try again.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "OdinWorkflowLoader",
  data: () => ({
    editor: null,
    loading: false,
    failed: false,
    observer: null,
    disposed: false,
    request: null,
  }),
  mounted() {
    if (!("IntersectionObserver" in window)) return this.load();
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.load();
      },
      { rootMargin: "700px 0px" },
    );
    this.observer.observe(this.$refs.loader);
  },
  beforeDestroy() {
    this.disposed = true;
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    load() {
      if (this.loading || this.editor) return this.request;
      this.loading = true;
      this.failed = false;
      this.request = import(
        /* webpackChunkName: "odin-workflow" */ "./OdinWorkflow.vue"
      )
        .then((module) => {
          if (!this.disposed) this.editor = module.default;
        })
        .catch(() => {
          this.failed = true;
        })
        .finally(() => {
          this.loading = false;
          if (this.observer) this.observer.disconnect();
        });
      return this.request;
    },
  },
};
</script>
